exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main{padding:10px;margin-top:0px;margin-bottom:50px}.main h1{color:#000000;font-size:24pt;font-weight:700}.main small{color:#000000}.about-us .quote{font-size:32px;font-weight:500}.donatebutton{margin-top:20px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/HomeElements/AboutUs.scss
// module id = 1046
// module chunks = 0